import { observable, action } from 'mobx';
import { getParkList } from '../../service/index';
import { deleteResource } from '../../native-interact/native-interface';
import { formatDateTime } from '../../js/utils';
import EventEmmiter, { log } from '../../native-interact/EventEmmiter';
// import nativeInterface from '../../native-interact/native';

let photoId = 0;
let audioId = 0;
const defaultForm = {
  abletime: localStorage.getItem('geo_abletime') || formatDateTime(+Date.now() + 7 * 24 * 60 * 60 * 1000, 'date'),
  parkinglotid: localStorage.getItem('parkinglotid') || '',
  parkinglotname: '',
  parkingno: localStorage.getItem('parkingno') || '',
  serial: '',
  lon: '',
  lat: '',
  remark: '',
  parkInSpeed: localStorage.getItem('geo_park_in_speed') || '0',
  parkOutSpeed: localStorage.getItem('geo_park_out_speed') || '-1'
};

export default class ParkStore extends EventEmmiter {
  @observable parks = [];

  @observable oldParkingno = '';

  @observable nowStart = true;

  @observable form = Object.assign({}, defaultForm);

  @observable photos = [];

  @observable audios = [];

  @observable photoState = 0; // 拍照状态，是否在拍摄场地环境照片（安装调试之前必须有一张场地照）

  @observable meter = ''; // 当前车位地磁对应绑定的控制器编号

  // @observable isParknoAudio = false //是否是车位输入时的语音输入

  @observable audioParkno = '' // 语音识别后的车位号文字

  // 蓝牙打开失败或者成功的消息
  @action getPark(mac) {
    return getParkList(mac)
      .then((data) => {
        this.oldParkingno = data.parkingno;
        this.parks = data;
        return data;
      });
  }

  @action getAudio(id) {
    return this.audios.find(item => item.id === id);
  }

  @action addPhoto(data) {
    photoId += 1;
    // 当前状态是否正在拍摄场地照
    const isLocationPhoto = this.photoState === 1;

    this.photos.push({
      id: `photo_${photoId}`,
      __location_photo__: isLocationPhoto, // 照片是否可以删除，如果是场地照则不能删除
      ...data
    });

    if (isLocationPhoto) {
      this.emmit('location_photo_end');
      this.photoState = 0;
    }
  }

  @action getAudioTxt(text) {
    console.log(text);
    this.audioParkno = text;
  }

  @action addAudio(data) {
    audioId += 1;
    this.audios.push({
      id: `audio_${audioId}`,
      ...data
    });
  }

  @action deletePhoto(id) {
    const index = this.photos.findIndex(item => item.id === id);
    return deleteResource(this.photos[index].path).then(() => {
      this.photos.splice(index, 1);
      return Promise.resolve();
    });
  }

  @action deleteAudio(id) {
    const index = this.audios.findIndex(item => item.id === id);
    return deleteResource(this.audios[index].url).then(() => {
      this.audios.splice(index, 1);
      return Promise.resolve();
    });
  }

  @action reset() {
    this.nowStart = true;
    // TODO 先删除照片和录音
    this.photos = [];
    this.audios = [];
    this.form = Object.assign({}, defaultForm);
    this.oldParkingno = '';
  }
}

export const parkStore = new ParkStore();
